import script from "./package-form-step2.vue?vue&type=script&lang=ts&setup=true"
export * from "./package-form-step2.vue?vue&type=script&lang=ts&setup=true"

import "./package-form-step2.vue?vue&type=style&index=0&id=141b19e8&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-141b19e8"]])

export default __exports__